import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SelectOption } from '../../option/default/select-option.component';
import { MultipleSelectOptionAdapter } from './multiple-select-option.adapter';

@Component({
  selector: 'app-multiple-select-option',
  templateUrl: './multiple-select-option.component.html',
  imports: [SelectOption, CommonModule],
})
export class MultipleSelectOption extends MultipleSelectOptionAdapter<any> {}
